module.exports.idFix=function(org){
  org= org.replace(/(id="[^"]+)_[0-9]+/,'$1')
  for (var i = 0; i <= 26; i++) {
    var reg = new RegExp('&#215;&#' + (144 + i) + ';', 'g')
    org = org.replace(reg, String.fromCharCode(1488 + i))
  }
  org=org.replace(/&#39;/,"'")
  return  org
}
